import { GET_HOTEL_BOOKING_FORM_DETAILS, GET_HOTEL_BOOKING_FORM_LIST, INSERT_UPDATE_HOTEL_BOOKING_FORM } from "../../utils/constants"


const initialState = [];

function hotelBookingFormReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {

        case GET_HOTEL_BOOKING_FORM_DETAILS:
            return [...state, payload];
        case GET_HOTEL_BOOKING_FORM_LIST:
            return [...state, payload];
        case INSERT_UPDATE_HOTEL_BOOKING_FORM:
            return [...state, payload];
        default:
            return state;
    }
};

export default hotelBookingFormReducer;